import styled from 'styled-components';

export const Panel = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;

  > span {
    user-select: none;
    font-size: 14px;
    color: white;
    flex-shrink: 1;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;

    &:last-child {
      color: rgba(255, 255, 255, 0.8);
      font-size: 12px;
    }
  }
`;
